export const AUDIT_PREFIX = '/audit';

export function usesAuditPrefix(pathname = '') {
  return pathname === AUDIT_PREFIX || pathname.startsWith(`${AUDIT_PREFIX}/`);
}

export function auditPath(path, pathname = '') {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  if (usesAuditPrefix(normalizedPath)) {
    return normalizedPath;
  }
  return usesAuditPrefix(pathname) ? `${AUDIT_PREFIX}${normalizedPath}` : normalizedPath;
}
